import styled from 'styled-components'

const mainColor = '#202020';
const subColor = '#565656';

export const GroupContainer = styled.div`
    margin-top: 0;
    width: 100%;

    &.reduceMargin {
        margin-top: -12px;
    }

    &.normal {
        margin: 12px 0;
    }
`

export const SelectLabel = styled.p`
    font-size: 11px;
    color: ${subColor};
`

export const SelectOption = styled.select`
    font-size: 16px;
    padding: 4px 0 8px 0;
    width: 100%;
    border: none;
    border-bottom: ${({ greybg }) => (greybg ? `1px solid #E3E3E3` : `1px solid ${subColor}`)};
    /* background-color: ${({ greybg }) => (greybg ? '#fafafa' : '')}; */
    background: none;
    color: ${({ greybg }) => (greybg ? `${subColor}` : `${mainColor}`)};

    &:focus {
        border-bottom:2px solid ${mainColor};
        outline: none;
    }

    /* &:hover {
        border-bottom: ${({ greybg }) => (greybg ? '' : `2px solid ${mainColor}`)}
    } */
`

export const OptionInput = styled.option`

`